import { useEffect, useState } from "react";
import apiClient from "@/lib/api";

/** Fetch-once cache for the public Website CMS config (homepage + branding). */
let _cache = null;
let _inflight = null;

export function usePublicSiteCms() {
  const [cfg, setCfg] = useState(_cache);
  useEffect(() => {
    if (_cache) { setCfg(_cache); return; }
    if (!_inflight) {
      _inflight = apiClient.get("/public/site-cms").then((r) => { _cache = r.data; return r.data; }).catch(() => null);
    }
    _inflight.then((data) => data && setCfg(data));
  }, []);
  return cfg;
}

export function orderedSections(cfg) {
  return (cfg?.sections || []).filter((s) => s.enabled).sort((a, b) => a.order - b.order);
}
